export default __webpack_public_path__ + "static/media/nestor.d457d53c.jpg";